 
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'
import _ from 'lodash'

import {
  UPDATE_EDIT_VALUE,
  UPDATE_PARTS,
  UPDATE_PART_DATA,
  UPDATE_LAST_UPDATED,
  UPDATE_LOADING_PART,
  CLEAR_EDIT_VALUE,
  FETCH_PARTS_START,
  FETCH_PARTS_SUCCESS,
  FETCH_PARTS_ERROR,
} from './constants'


const updateEditValue = (prev, { key, value }) => { return {...prev, [key]: value} }
const updatePartLoading = (prev, { part, value }) => { return {...prev, [part]: value} }
const updateLastUpdated = (prev, { part, value }) => { return {...prev, [part]: value} }
const updateParts = (prev, { parts }) => parts
const updatePartData = (prev, { partName, partData }) => { return {...prev, [partName]: partData} }
const toggleFlag = (value) => !value

const editSliceReducer = createReducer(false, {
  [CLEAR_EDIT_VALUE]: () => false,
  [UPDATE_EDIT_VALUE]: updateEditValue
})

const partsReducer = createReducer({}, {
  [UPDATE_PARTS]: updateParts,
  [UPDATE_PART_DATA]: updatePartData
})

const loadingStart = [[FETCH_PARTS_START]]
const loadingSuccess = [[FETCH_PARTS_SUCCESS]]
const loadingError = [[FETCH_PARTS_ERROR]]
let loadingStates = loadingStart.concat(loadingSuccess, loadingError)
let reducerObj = {}
loadingStates.forEach(s => reducerObj[s] = toggleFlag)
const fetchingPartsReducer = createReducer(false, reducerObj)

const loadingPartReducer = createReducer({}, {
  [UPDATE_LOADING_PART]: updatePartLoading
})

const lastUpdatedReducer = createReducer({}, {
  [UPDATE_LAST_UPDATED]: updateLastUpdated
})

export default combineReducers({
  edit: editSliceReducer,
  parts: partsReducer,
  lastUpdated: lastUpdatedReducer,
  isLoading: fetchingPartsReducer,
  isCreatingPart: loadingPartReducer,
})